/**
 * Progressive webfont loading
 *
 * @package Embark
 * @since   1.0.0
 */

import FontFaceObserver from 'fontfaceobserver/fontfaceobserver.standalone.js';
import { els } from './variables';

/**
 * On first page load, load all fonts using FontFaceObserver and then
 * add the .fonts-loaded class to the html element, and set the emFontsLoaded
 * cookie to true. On subsequent page loads, head.js checks for the cookie,
 * and, if it's set, adds the class. This script will check to for the
 * .fonts-loaded class and see that it's already there and not load the
 * fonts again, since they are cached.
 *
 * @since  1.0.0
 */
if (!els.html.classList.contains('fonts-loaded')) {
	Promise
		.all([
			new FontFaceObserver('Montserrat').load(),
			new FontFaceObserver('Aileron').load(),
		])
		.then(() => {
			els.html.classList.add('fonts-loaded');
			document.cookie = 'emFontsLoaded=true;';
		});
}
